import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData, postData } from "../../serverRequest";
import LoadingSpinner from "../../components/Loadder";
// import moment from 'moment';
// components
import UserAttendanceApprovalTable from "../Tables/UserAttendanceApprovalTable.js";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



export default function UserAttendanceApproval({ color }) {
  // const [open, setOpen] = React.useState(true);
  //const [openTickets, setOpenTickets] = React.useState([]);
  //const [closedTicket, setclosedTicket] = React.useState();
  const [attendanceApproval, setAttendanceApproval] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(window.location.search);

  const ticketFilter = searchParams.get('filter');
  //console.log(ticketFilter);
  // const toggleDrawer = () => {
  //   setOpen(!open);
  // };

  // const formatDate = (dateString) => {
  //   return moment(dateString).format('DD/MM/YYYY');
  // };

  const filterTicketData = (tickets_data) => {
    //console.log(tickets_data);
    let openTicket = [];
    let closeTicket = [];
    let totalTicket = [];
    if (tickets_data) {
      for (let i = 0; i < tickets_data.length; i++) {
        if (tickets_data[i]['status'] !== 'Resolved') {
          openTicket.push(tickets_data[i]);
          totalTicket.push(tickets_data[i]);
        }
        else if (tickets_data[i]['status'] === 'Resolved') {
          closeTicket.push(tickets_data[i]);
          totalTicket.push(tickets_data[i]);
        }
        else {
          totalTicket.push(tickets_data[i]);
        }
      }
    }

    if (ticketFilter === 'open') {
      totalTicket = openTicket;
    }
    else if (ticketFilter === 'closed') {
      totalTicket = closeTicket
    }

    //console.log(totalTicket);
    setAttendanceApproval(totalTicket);
    return ({ "open": openTicket, "close": closeTicket, "total": totalTicket })
  }
  React.useEffect(() => {
    async function fetchData() {
      let resData = await getData('/api/employee/leave_request?approver_id=' + localStorage.getItem('employeeId') + '&company_id=' + localStorage.getItem('companyId'));
      let approval_data = resData['data']['leave_requests'];
      console.log(approval_data);
      // let ticketData = await filterTicketData(tickets_data)
      setLoading(false);
      setAttendanceApproval(approval_data);

    }
    fetchData();


  }, [])

  return (
    <>
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <>
          <div
            className={
              "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
              "bg-white"
            }
          >
            <div className="rounded-t mb-0 px-4 py-3 border-0">
              <div className="flex flex-wrap items-center">
                <div className="relative w-full px-4 max-w-full flex-grow flex-1 ">
                  <h3
                    className={
                      "font-semibold text-lg " + "text-blueGray-700"
                    }
                  >
                    Attendance Approval
                  </h3>
                </div>
              </div>
            </div>
            <div className="block w-full overflow-x-auto mb-0 px-4 py-3">
              <table
                id="userAttendanceApproval"
                className="items-center w-full bg-transparent border-collapse"
              >
                <thead>
                  <tr>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Employee Name
                    </th>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Leave Type
                    </th>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Total Days
                    </th>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Date Range
                    </th>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Reason
                    </th>
                    <th
                      className={
                        "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                        " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      }
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {attendanceApproval && attendanceApproval.map((item, index) => (
                    <tr key={index}>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        {item.employee_name}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        {item.leave_type}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        {item.total_days}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        {item.start_date} - {item.end_date}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        {item.reason}
                      </td>
                      <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                        <button
                          className="bg-green-500 text-white px-3 py-1 rounded mr-2"
                          onClick={() => handleAction(item.id, "Approved")}
                        >
                          Approve
                        </button>
                        <button
                          className="bg-red-500 text-white px-3 py-1 rounded"
                          onClick={() => handleAction(item.id, "Rejected")}
                        >
                          Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ToastContainer />
          </div>
        </>
      )}
    </>
  );

  async function handleAction(id, action) {
    console.log(`Action: ${action} for ID: ${id}`);
    setLoading(true);
    const reqData = {
      leave_request_id: id,
      approver_id: localStorage.getItem('employeeId'),
      company_id: localStorage.getItem('companyId'),
      action: action
    };
    // Add logic to handle approve/reject action
    //console.log(reqData);
    let resData = await postData('/api/employee/approver_action/', reqData)
    setLoading(false);
    //console.log("This is data")
    //console.log(resData)
    if (resData['data']['code'] === 200) {
      setLoading(false);
      toast.success(resData['data']['message']);
      setTimeout(() => {
        window.location.reload();
      }, 2000);

      //console.log("This is good example");
      //window.location.href = '/user/dashboard';
    }
    else {
      toast.error(resData['data']['message']);
      //setErrorMessages({ name: "uname", message: errors.uname });
    }
  }
}

UserAttendanceApproval.defaultProps = {
  color: "light",
};

UserAttendanceApproval.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
